import React from "react";
import "../contentcards/CardTag";

const Tag: React.FC<{ title: string }> = ({ title }) => {
  return <p className="tag card-tag">{title}</p>;
};

export default Tag;
